// extracted by mini-css-extract-plugin
export default {"Page":"style_Page__-8wsv"};